import styled from 'react-emotion'

import { Typo24WhiteNBI } from '../../../../../themes/Fonts/Nort'
import { Typo16GainsBoroDR } from '../../../../../themes/Fonts/Din2014'
import { mobile, tablet, customDevice } from '../../../../../utils/mixins'
import CloudinaryS3LazyLoadedImage from '../../../../CloudinaryS3LazyLoadedImage'

export const ImageAndContentContainer = styled('div')`
  margin-bottom: 60px;
  display: flex;
  flex-direction: ${props => (props.isEven ? 'row-reverse' : 'row')};
  justify-content: space-between;
  align-items: center;

  ${mobile} {
    display: block;
    margin-top: 50px;
    margin-bottom: 0px;
  }
`

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: ${props => (props.isEven ? '47%' : '53%')};
  padding-right: ${props => (props.isEven ? '0px' : '4.188em')};

  ${mobile} {
    width: 100%;
    display: block;
    padding: 0px;
  }

  ${tablet} {
    width: 50%;
  }

  ${customDevice(768, 959)} {
    padding-right: ${props => (props.isEven ? '15px' : '0px')};
  }

  ${customDevice(960, 1024)} {
    padding-right: ${props => (props.isEven ? '0px' : '30px')};
  }
`

export const ContentContainer = styled.div`
  width: ${props => (props.isEven ? '53%' : '47%')};
  display: flex;
  flex-direction: column;
  padding-right: ${props => (props.isEven ? '4.188em' : '0px')};

  ${mobile} {
    width: 100%;
    display: block;
    padding: 0px;
  }

  ${tablet} {
    width: ${props => (props.isEven ? '50%' : '45%')};
  }

  ${customDevice(768, 959)} {
    padding-right: ${props => (props.isEven ? '15px' : '0px')};
  }

  ${customDevice(960, 1024)} {
    padding-right: ${props => (props.isEven ? '30px' : '0px')};
  }
`

export const SectionImage = styled(CloudinaryS3LazyLoadedImage)`
  width: 480px;
  height: 270px;
  object-fit: fill;
  background-color: transparent;
  margin: 0px;
  cursor: pointer;

  ${tablet} {
    width: 345px;
    height: 195px;
  }

  ${customDevice(1024, 1199)} {
    width: 400px;
    height: auto;
  }
`
export const FutureItemImg = styled(CloudinaryS3LazyLoadedImage)`
  width: 345px;
  height: 195px;
  object-fit: fill;
  background-color: transparent;
  margin: 0px;
  margin-top: 20px;
  cursor: pointer;

  ${customDevice(320, 360)} {
    width: 100%;
  }
`

export const FutureTextItem = styled('div')`
  display: flex;
  flex-direction: column;
  border-radius: 6px;

  ${mobile} {
    align-items: center;
  }
`
export const FutureItemHead = styled('div')`
  text-align: ${props => (props.isEven ? 'right' : 'left')};

  ${mobile} {
    text-align: center;
  }
`

export const FutureItemTitle = styled(Typo24WhiteNBI)`
  align-self: flex-start;
  text-align: left;
  margin: 0;
  letter-spacing: 1px;
  line-height: normal;

  ${mobile} {
    margin: 0;
    font-size: 18px;
    letter-spacing: 0.75px;
  }
`
export const FutureImageItem = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 5% 2%;
  border-radius: 6px;

  ${customDevice(320, 425)} {
    padding: 15px 0px;
  }

  ${customDevice(425, 767)} {
    padding: 20px 3px;
  }
`

export const FutureSection = styled('section')`
  ${tablet} {
    margin-bottom: 40px;
  }
`

export const FutureItemDescription = styled(Typo16GainsBoroDR)`
  margin-top: 10px;
  margin-bottom: 20px;
  line-height: 1.63;
  letter-spacing: normal;

  ${mobile} {
    display: none;
  }
`

export const MobileFutureItemDescription = styled(Typo16GainsBoroDR)`
  margin-top: 20px;
  letter-spacing: normal;
  display: none;

  ${mobile} {
    display: block;
    font-size: 14px;
    line-height: 1.5;
  }
`

export const ButtonContainer = styled('div')`
  ${mobile} {
    margin: auto;
    margin-top: 20px;
  }
`



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/ExperimentalMarketingSection/components/Section/styledComponents.js